import Tracker from '@ali/tracker';
import InterfacePlugin from '@ali/tracker/plugins/Interface';
import PerformancePlugin from '@ali/tracker/plugins/Performance';

const tracker = new Tracker({
  pid: 'story-rebuild',
  plugins: [
    [InterfacePlugin],
    [PerformancePlugin],
  ],
});

export function doClueTracking() {
// 启动 tracker 并监听全局 JS 异常
  tracker.install();

}

// 自定义监控
//   tracker.log({
//     code: 12,
//     msg: '自定义msg',
//   });
